// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Leftbar from "../../layout/Leftbar";
import Topbar from "../../layout/Topbar";
import { Loader2 } from "../../../loader/Loader";
import useFetch from "../../../../ApiClient/GetApi";
import Moment from "react-moment";
import { PostApi } from "../../../../ApiClient/PostApi";
import { success_toaster, error_toaster } from "../../../toaster/Toaster";
import { FormControl, FormLabel, Switch } from "@chakra-ui/react";
import { Radio } from "flowbite-react";
export default function MeasuredOrder() {
  // const hscodes = useFetch(`get_hscode_country`);
  const location = useLocation();

  const navigate = useNavigate();
  const { data, reFetch } = useFetch(`order_detail/${location?.state?.id}`);
  const companies = useFetch(`get_active_companies/${location?.state?.id}`);
  const [loading, SetLoading] = useState(false);
  const [repack, setRepack] = useState(false);
  const [company, setCompany] = useState("");
  const [originId, setOriginId] = useState("");
  const [countryId, setCountryId] = useState("");
  const [insurance, setInsurance] = useState("");
  const [serviceType, setServiceType] = useState("");

  const [edit, setEdit] = useState([
    {
      id: "",
      length: "",
      width: "",
      height: "",
      weight: "",
      qty: "",
    },
  ]);

  const [productData, setProductData] = useState([
    {
      id: "",
      Description: "",
      HsCode: "",
      OriginId: "",
      CountryId: "",
      price: "",
      quantity: "",
      weight: "",
    },
  ]);

  const [consolidation, setConsolidation] = useState({
    length: "",
    width: "",
    height: "",
    weight: "",
    qty: "",
  });

  const onPackChange = (e, index, packageId) => {
    const { name, value } = e.target;
    const newPackages = [...edit];

    newPackages[index] = {
      ...newPackages[index],
      id: packageId,
      [name]: value,
    };

    setEdit(newPackages);
  };

  const onProductChange = (e, index, productId) => {
    const { name, value } = e.target;
    const newProducts = [...productData];

    newProducts[index] = {
      ...newProducts[index],
      id: productId,
      OriginId: originId,
      CountryId: countryId,
      [name]: value,
    };

    setProductData(newProducts);
  };

  const consolidationOnChange = (e) => {
    setConsolidation({ ...consolidation, [e.target.name]: e.target.value });
  };

  const remeasuredOrder = async () => {
    let isError = false;
    // Validate each object in the edit array
    if (!repack) {
      for (const item of edit) {
        if (!item.length) {
          error_toaster("Package length is required");
          isError = true;
          break;
        }
        if (!item.width) {
          error_toaster("Package width is required");
          isError = true;
          break;
        }
        if (!item.height) {
          error_toaster("Package height is required");
          isError = true;
          break;
        }
        if (!item.weight) {
          error_toaster("Package weight is required");
          isError = true;
          break;
        }
        if (!item.qty) {
          error_toaster("Package quantity is required");
          isError = true;
          break;
        }
      }
      if (isError) return;
    }
    // Validate consolidation object if repack is true
    if (repack) {
      if (!consolidation.length) {
        error_toaster("Consolidation length is required");
        return;
      }
      if (!consolidation.width) {
        error_toaster("Consolidation width is required");
        return;
      }
      if (!consolidation.height) {
        error_toaster("Consolidation height is required");
        return;
      }
      if (!consolidation.weight) {
        error_toaster("Consolidation weight is required");
        return;
      }
      if (!consolidation.qty) {
        error_toaster("Consolidation quantity is required");
        return;
      }
    }
    // Validate each object in the productData array
    for (const item of productData) {
      if (!item.quantity) {
        error_toaster("Product quantity is required");
        isError = true;
        break;
      }
      if (!item.weight) {
        error_toaster("Product weight is required");
        isError = true;
        break;
      }
      if (!item.Description) {
        error_toaster("Product description is required");
        isError = true;
        break;
      }
      if (!item.HsCode) {
        error_toaster("Product HS code is required");
        isError = true;
        break;
      }
      if (!item.price) {
        error_toaster("Product price is required");
        isError = true;
        break;
      }
    }
    if (isError) return;

    // Proceed with API call if all validations pass
    SetLoading(true);
    const res = await PostApi("remeasured_order", {
      packages: repack ? [consolidation] : edit,
      products: productData,
      repacking: repack,
      service: serviceType,
      company: company,
      product_insurance: insurance,
      bookingId: location?.state?.id,
    });

    if (res?.data?.status === "1") {
      SetLoading(false);
      success_toaster(res.data.message);
      reFetch();
    } else {
      error_toaster(res?.data?.message || "Unable to save measured order");
      SetLoading(false);
    }
  };

  useEffect(() => {
    if (data?.data?.booking?.repackingPrice !== null) {
      setRepack(true);
    } else {
      setRepack(false);
    }
    if (data?.data?.booking?.CompanyCountry?.OriginId) {
      setOriginId(data?.data?.booking?.CompanyCountry?.OriginId);
      setCountryId(data?.data?.booking?.CompanyCountry?.DestinationId);
      setInsurance(data?.data?.booking?.insurance);
      setServiceType(data?.data?.booking?.serviceType);
    }
  }, [data]);

  const companyHandleChange = (event) => {
    let index = event.target.value;
    setCompany(index);
  };

  const update_order_company = async () => {
    if (company === "") {
      error_toaster("Please select a Company!");
      return false;
    }
    SetLoading(true);
    const res = await PostApi("update_order_company", {
      companyId: company,
      orderId: data?.data?.booking?.id,
    });

    if (res.data.status === "1") {
      success_toaster(res.data.message);
      SetLoading(false);
      reFetch();
    } else {
      error_toaster(res.data.message);
      SetLoading(false);
    }
  };

  const add_product_dimension = async (id) => {
    if (productData.qty === "" || productData.qty === null) {
      error_toaster("Product Quantity is required!");
      return false;
    } else if (productData.weight === "" || productData.weight === null) {
      error_toaster("Product weight is required!");
      return false;
    } else if (
      productData.description === "" ||
      productData.description === null
    ) {
      error_toaster("Product description is required!");
      return false;
    } else {
      SetLoading(true);
      const res = await PostApi("add_product_dimension", {
        productId: id,
        weight: productData.weight,
        HsCode: productData.HsCode,
        Country: productData.Country,
        qty: productData.qty,
        description: productData.description,
      });
      if (res.data.status === "1") {
        SetLoading(false);
        success_toaster(res.data.message);
        reFetch();
      } else if (res.data.status === "2") {
        navigate("/login");
      } else {
        error_toaster(res.data.message);
        SetLoading(false);
      }
    }
  };

  // Add Consolidation Dimesions
  const addConsolidationDimensions = async (id) => {
    if (consolidation.length === "") {
      error_toaster("Consolidation length is required");
    } else if (consolidation.width === "") {
      error_toaster("Consolidation width is required");
    } else if (consolidation.height === "") {
      error_toaster("Consolidation height is required");
    } else if (consolidation.weight === "") {
      error_toaster("Consolidation weight is required");
    } else if (consolidation.qty === "") {
      error_toaster("Consolidation quantity is required");
    } else {
      SetLoading(true);
      const res = await PostApi("add_Consolidation", {
        bookingId: id,
        height: consolidation.height,
        weight: consolidation.weight,
        length: consolidation.length,
        width: consolidation.width,
        qty: consolidation.qty,
      });
      if (res?.data?.status === "1") {
        SetLoading(false);
        success_toaster(res?.data?.message);
      } else {
        SetLoading(false);
        error_toaster(res?.data?.message);
      }
    }
  };

  const add_dimension = async (id) => {
    if (edit.length === "") {
      error_toaster("Package length is required");
    } else if (edit.width === "") {
      error_toaster("Package width is required");
    } else if (edit.height === "") {
      error_toaster("Package height is required");
    } else if (edit.weight === "") {
      error_toaster("Package weight is required");
    } else if (edit.qty === "") {
      error_toaster("Package quantity is required");
    } else {
      SetLoading(true);
      const res = await PostApi("add_dimension", {
        packageId: id,
        length: edit.length,
        width: edit.width,
        height: edit.height,
        weight: edit.weight,
        qty: edit.qty,
      });

      if (res.data.status === "1") {
        SetLoading(false);
        success_toaster(res.data.message);
        reFetch();
      } else {
        error_toaster(res.data.message);
        SetLoading(false);
      }
    }
  };
  const repacking_price = async () => {
    SetLoading(true);
    const res = await PostApi("repacking_price", {
      repack: repack,
      bookingId: data?.data?.booking?.id,
    });
    if (res.data.status === "1") {
      success_toaster(res.data.message);
      SetLoading(false);
      reFetch();
    } else {
      error_toaster(res.data.message);
      SetLoading(false);
    }
  };

  const send_invoice = async () => {
    if (data?.data?.booking?.confirmTotalPrice === null) {
      error_toaster("Please measure the dimensions first!");
      return false;
    }
    SetLoading(true);

    const res = await PostApi("send_invoice", {
      orderId: data?.data?.booking?.id,
      repack: repack,
      totalPrice: data?.data?.booking?.confirmTotalPrice,
      orderStatus: data?.data?.booking?.bookingStatus,
      expectedHubArrivalDate: data?.data?.booking?.expectedHubArrivalDate,
      packages: data?.data?.booking?.Packages,
      products: data?.data?.booking?.Products,
      DestinationDetail: data?.data?.booking?.DestinationDetail,
      SupplierDetail: data?.data?.booking?.SupplierDetail,
      ConsigneeDetail: data?.data?.booking?.ConsigneeDetail,
      company: data?.data?.booking?.Company,
    });
    // return false
    if (res.data.status === "1") {
      SetLoading(false);
      success_toaster(res.data.message);
      reFetch();
      // window.location.reload()
    } else {
      SetLoading(false);
      error_toaster(res.data.message);
    }
  };

  const thStyle =
    "border border-black font-medium sm:text-base text-xs text-black uppercase p-2";
  const tdStyle =
    "border border-black font-normal sm:text-base text-xs text-black text-opacity-60 p-2";
  const tdStyle2 = "font-normal text-base text-black text-opacity-60 py-2";
  const tdStyle3 = "font-normal text-base text-black py-2 px-2";
  const liStyle =
    "border border-black font-normal sm:text-base text-xs text-black py-2 sm:px-3 px-1 whitespace-nowrap";
  return (
    <>
      <Leftbar />
      <Topbar main="Measured Values" extend={false} />
      {loading ? (
        <div>
          <Loader2 />
        </div>
      ) : (
        <section className="relative xl:w-[calc(100%-280px)] w-[calc(100%-240px)] top-[148px]  px-10 float-right space-y-8">
          <div className="flex justify-end">
            <button
              onClick={send_invoice}
              className="py-3 px-6 bg-themeGreen rounded text-green-700 border border-themeGreen hover:bg-white"
            >
              Generate Invoice
            </button>
          </div>
          <div className="flex justify-between">
            {/* <div className="flex justify-between border p-3 shadow-md rounded bg-themeBlue text-white hover:bg-white hover:text-themeBlue cursor-pointer"> */}
            <p className="text-lg font-semibold ">
              <span className="bg-themeBlue p-2 text-white rounded">
                Order ID
              </span>{" "}
              {data?.data?.booking?.id ?? ""}
            </p>
            <p className="text-lg font-semibold">
              <span className="bg-themeBlue p-2 text-white rounded">
                Hub Arrival Date
              </span>{" "}
              <Moment format="D MMM, YYYY hh:mm a">
                {data?.data?.booking?.expectedHubArrivalDate}
              </Moment>
            </p>
            <p className="text-lg font-semibold">
              <span className="bg-themeBlue p-2 text-white rounded">
                Est. Price
              </span>{" "}
              {data?.data?.booking?.totalPrice ?? ""}
            </p>
            <p className="text-lg font-semibold">
              <span className="bg-themeBlue p-2 text-white rounded">
                Confirm Price
              </span>{" "}
              {data?.data?.booking?.confirmTotalPrice === null
                ? "0.00"
                : data?.data?.booking?.confirmTotalPrice}
            </p>
          </div>
          <div className="flex gap-x-4 justify-between border-2 p-3 rounded">
            <p className="text-lg font-semibold text-themeBlue">
              Service Type : {data?.data?.booking?.serviceType ?? ""}
            </p>
            <p className="text-lg font-semibold text-themeBlue">
              Company : {data?.data?.booking?.Company?.name ?? ""}
            </p>
            <p className="text-lg font-semibold text-themeBlue">
              Insurance : {data?.data?.booking?.insurance ? "Yes" : "No"}
            </p>
          </div>
          {/* {data?.data?.booking?.repackingPrice ? (
            <p className="text-lg font-semibold text-themeBlue">
              Repacking : Yes
            </p>
          ) : (
            <p className="text-lg font-semibold text-themeBlue">
              Repacking : No
            </p>
          )} */}

          <>
            <FormControl
              display="flex"
              alignItems="center"
              className="space-x-4"
            >
              <FormLabel htmlFor="email-alerts" mb="0">
                Do you want repacking and consolidation of your Shipment?
              </FormLabel>
              <Switch
                isChecked={repack}
                onChange={() => setRepack(!repack)}
                id="email-alerts"
              />
              <FormLabel htmlFor="email-alerts" mb="0">
                Do you want insurance of your products?
              </FormLabel>
              <Switch
                isChecked={insurance}
                onChange={() => setInsurance(!insurance)}
                id="email-alerts"
              />
            </FormControl>

            <div className="flex items-center gap-x-6 mt-3 ml-0.5">
              <FormLabel htmlFor="email-alerts" mb="0">
                Do you want insurance of your products?
              </FormLabel>
              <div className="flex items-center gap-2">
                <Radio
                  onChange={(e) => setServiceType(e.target.value)}
                  id="full_services"
                  name="services"
                  value="Full Services"
                  checked={serviceType === "Full Services" ? true : false}
                  className="border-2 border-black border-opacity-60 checked:bg-black focus:ring-0 focus:outline-black"
                />
                <FormLabel htmlFor="full_services" mb="0">
                  Full Import service
                </FormLabel>
              </div>
              <div className="flex items-center gap-2">
                <Radio
                  onChange={(e) => setServiceType(e.target.value)}
                  id="import_services"
                  name="services"
                  value="Shipping Service"
                  checked={serviceType === "Shipping Service" ? true : false}
                  className="border-2 border-black border-opacity-60 checked:bg-black focus:ring-0 focus:outline-black"
                />
                <FormLabel htmlFor="import_services" mb="0">
                  Shipping Service only
                </FormLabel>
              </div>
            </div>
          </>

          <div className="grid gap-x-4 gap-y-4">
            {repack ? (
              <div className="bg-white py-6 px-5 rounded-lg space-y-4 overflow-auto">
                <div className="flex justify-between items-center gap-x-4">
                  <h1 className="font-medium sm:text-2xl text-xl text-themeBlue">
                    Consolidation Details
                  </h1>
                </div>
                <div className="block">
                  <table>
                    <tbody className="w-full">
                      <div className="border-2 rounded-lg p-2 my-4">
                        <tr>
                          <td className={tdStyle3}>DIMENSIONS</td>
                          <td className={tdStyle3}>Length (cm)</td>
                          <td className={tdStyle3}>Width (cm)</td>
                          <td className={tdStyle3}>Height (cm)</td>
                          <td className={tdStyle3}>Weight (kg)</td>
                          <td className={tdStyle3}>Quantity</td>
                        </tr>
                        <tr>
                          <td className={tdStyle3}>Measured</td>
                          <td className={tdStyle3}>
                            <input
                              name="length"
                              onChange={consolidationOnChange}
                              className="bg-themeGray py-2 px-3 focus:outline-themeGray2"
                              placeholder={
                                data?.data?.ConsolidationPackage?.measuredLength
                              }
                            />
                          </td>
                          <td className={tdStyle3}>
                            <input
                              name="width"
                              onChange={consolidationOnChange}
                              className="bg-themeGray py-2 px-3 focus:outline-themeGray2"
                              placeholder={
                                data?.data?.ConsolidationPackage?.measuredWidth
                              }
                            />
                          </td>
                          <td className={tdStyle3}>
                            <input
                              name="height"
                              onChange={consolidationOnChange}
                              className="bg-themeGray py-2 px-3 focus:outline-themeGray2"
                              placeholder={
                                data?.data?.ConsolidationPackage?.measuredWeight
                              }
                            />
                          </td>
                          <td className={tdStyle3}>
                            <input
                              name="weight"
                              onChange={consolidationOnChange}
                              className="bg-themeGray py-2 px-3 focus:outline-themeGray2"
                              placeholder={
                                data?.data?.ConsolidationPackage?.measuredWeight
                              }
                            />
                          </td>
                          <td className={tdStyle3}>
                            <input
                              name="qty"
                              onChange={consolidationOnChange}
                              className="bg-themeGray py-2 px-3 focus:outline-themeGray2"
                              placeholder={
                                data?.data?.ConsolidationPackage?.quantity
                              }
                            />
                          </td>
                        </tr>
                        {/* <tr>
                          <td className={tdStyle3}>
                            <button
                              onClick={() => {
                                addConsolidationDimensions(
                                  data?.data?.booking?.id
                                );
                              }}
                              className="py-1 px-8 bg-themeBlue border border-themeBlue text-white 
                              rounded hover:bg-white hover:text-themeBlue"
                            >
                              Submit
                            </button>
                          </td>
                        </tr> */}
                      </div>
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="bg-white py-6 px-5 rounded-lg space-y-4 overflow-auto">
                <div className="flex justify-between items-center gap-x-4">
                  <h1 className="font-medium sm:text-2xl text-xl text-themeBlue">
                    Package Details
                  </h1>
                </div>
                <div className="block">
                  <table>
                    <tbody className="w-full">
                      {data?.data?.booking?.Packages?.map((pack, index) => (
                        <>
                          <h2 className="font-medium text-xl text-themeBlue">
                            Package ID {pack?.id}
                          </h2>
                          <div
                            className="border-2 rounded-lg p-2 my-4"
                            key={pack.id}
                          >
                            <tr>
                              <td className={tdStyle3}>DIMENSIONS</td>
                              <td className={tdStyle3}>Length (cm)</td>
                              <td className={tdStyle3}>Width (cm)</td>
                              <td className={tdStyle3}>Height (cm)</td>
                              <td className={tdStyle3}>Weight (kg)</td>
                              <td className={tdStyle3}>Quantity</td>
                            </tr>
                            <tr>
                              <td className={tdStyle3}>Captured</td>
                              <td className={tdStyle3}>
                                {pack?.captureLength?.toFixed(1)}
                              </td>
                              <td className={tdStyle3}>
                                {pack?.captureWidth?.toFixed(1)}
                              </td>
                              <td className={tdStyle3}>
                                {pack?.captureHeight?.toFixed(1)}
                              </td>
                              <td className={tdStyle3}>
                                {pack?.captureWeight?.toFixed(1)}
                              </td>
                              <td className={tdStyle3}>{pack?.qty}</td>
                            </tr>
                            <tr>
                              <td className={tdStyle3}>Measured</td>
                              <td className={tdStyle3}>
                                <input
                                  name="length"
                                  placeholder={pack?.measuredLength}
                                  onChange={(e) =>
                                    onPackChange(e, index, pack?.id)
                                  }
                                  className="bg-themeGray py-2 px-3 focus:outline-themeGray2"
                                />
                              </td>
                              <td className={tdStyle3}>
                                <input
                                  name="width"
                                  placeholder={pack?.measuredWidth}
                                  onChange={(e) =>
                                    onPackChange(e, index, pack?.id)
                                  }
                                  className="bg-themeGray py-2 px-3 focus:outline-themeGray2"
                                />
                              </td>
                              <td className={tdStyle3}>
                                <input
                                  name="height"
                                  placeholder={pack?.measuredHeight}
                                  onChange={(e) =>
                                    onPackChange(e, index, pack?.id)
                                  }
                                  className="bg-themeGray py-2 px-3 focus:outline-themeGray2"
                                />
                              </td>
                              <td className={tdStyle3}>
                                <input
                                  name="weight"
                                  placeholder={pack?.measuredWeight}
                                  onChange={(e) =>
                                    onPackChange(e, index, pack?.id)
                                  }
                                  className="bg-themeGray py-2 px-3 focus:outline-themeGray2"
                                />
                              </td>
                              <td className={tdStyle3}>
                                <input
                                  name="qty"
                                  placeholder={pack?.qty}
                                  onChange={(e) =>
                                    onPackChange(e, index, pack?.id)
                                  }
                                  className="bg-themeGray py-2 px-3 focus:outline-themeGray2"
                                />
                              </td>
                            </tr>
                            {/* <tr>
                              <td className={tdStyle3}>
                                <button
                                  onClick={() => add_dimension(pack.id)}
                                  className="py-1 px-8 bg-themeBlue border border-themeBlue text-white rounded hover:bg-white hover:text-themeBlue"
                                >
                                  Submit
                                </button>
                              </td>
                            </tr> */}
                          </div>
                        </>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <div className="bg-white py-6 px-5 rounded-lg space-y-4 overflow-auto">
              <div className="flex justify-between items-center gap-x-4">
                <h1 className="font-medium sm:text-2xl text-xl text-themeBlue">
                  Product Details
                </h1>
              </div>
              <div className="block">
                <table>
                  <tbody>
                    {data?.data?.booking?.Products?.map((pack, index) => (
                      <>
                        <h2 className="font-medium text-xl text-themeBlue">
                          Product ID {pack?.id}
                        </h2>
                        <div
                          className="border-2 rounded-lg p-2 my-4"
                          key={pack.id}
                        >
                          <tr>
                            <td className={tdStyle3}>DIMENSIONS</td>
                            <td className={tdStyle3}>Quantity</td>
                            <td className={tdStyle3}>Weight (kg)</td>
                            <td className={tdStyle3}>Description</td>
                            <td className={tdStyle3}>HsCode</td>
                            <td className={tdStyle3}>Price</td>
                          </tr>
                          <tr>
                            <td className={tdStyle3}>Captured</td>
                            <td className={tdStyle3}>{pack?.qty}</td>
                            <td className={tdStyle3}>
                              {pack?.weight?.toFixed(1)}
                            </td>
                            <td className={tdStyle3}>{pack?.description}</td>
                            <td className={tdStyle3}>{pack?.HsCode?.HsCode}</td>
                            <td className={tdStyle3}>{pack?.price}$</td>
                          </tr>
                          <tr>
                            <td className={tdStyle3}>Measured</td>
                            <td className={tdStyle3}>
                              <input
                                name="quantity"
                                placeholder={pack.qty}
                                onChange={(e) =>
                                  onProductChange(e, index, pack?.id)
                                }
                                className="bg-themeGray py-2 px-3 focus:outline-themeGray2"
                              />
                            </td>
                            <td className={tdStyle3}>
                              <input
                                name="weight"
                                placeholder={pack.weight}
                                onChange={(e) =>
                                  onProductChange(e, index, pack?.id)
                                }
                                className="bg-themeGray py-2 px-3 focus:outline-themeGray2"
                              />
                            </td>

                            <td className={tdStyle3}>
                              <input
                                name="Description"
                                placeholder={pack.description}
                                onChange={(e) =>
                                  onProductChange(e, index, pack?.id)
                                }
                                className="bg-themeGray py-2 px-3 focus:outline-themeGray2"
                              />
                            </td>

                            <td className={tdStyle3}>
                              <input
                                name="HsCode"
                                placeholder={pack.HsCode?.HsCode}
                                onChange={(e) =>
                                  onProductChange(e, index, pack?.id)
                                }
                                className="bg-themeGray py-2 px-3 focus:outline-themeGray2"
                              />
                            </td>
                            <td className={tdStyle3}>
                              <input
                                name="price"
                                placeholder={pack.price}
                                onChange={(e) =>
                                  onProductChange(e, index, pack?.id)
                                }
                                className="bg-themeGray py-2 px-3 focus:outline-themeGray2"
                              />
                            </td>

                            {/* <td className={tdStyle3}>

                                                                <select name="Country" onChange={ProductonChange} className="bg-themeGray py-3 rounded px-1">
                                                                    <option>Select Country</option>
                                                                    {
                                                                        hscodes?.data?.data?.countries?.map((country) => (
                                                                            <option value={country.id}>{country.name}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </td> */}
                          </tr>
                          {/* <tr>
                            <td className={tdStyle3}>
                              <button
                                onClick={() => add_product_dimension(pack.id)}
                                className="py-1 px-8 bg-themeBlue border border-themeBlue text-white rounded hover:bg-white hover:text-themeBlue"
                              >
                                Submit
                              </button>
                            </td>
                          </tr> */}
                        </div>
                      </>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div>
            <h1 className="font-medium sm:text-2xl text-xl text-themeBlue">
              Company Selection
            </h1>
            <p>
              Current Company :{" "}
              <span className="text-lg font-semibold">
                {data?.data?.booking?.Company?.name}
              </span>
            </p>
            <div className="flex gap-4 flex-wrap my-4">
              {companies?.data?.data?.map((com, index) => (
                <div className="px-4 w-[240px] py-6 rounded-lg bg-white border border-themeBlue">
                  <div className="flex items-center gap-2">
                    <input
                      type="radio"
                      // name="Company"
                      value={com.id}
                      checked={
                        com?.Company?.id === data?.data?.booking?.CompanyId
                          ? true
                          : false
                      }
                      onChange={companyHandleChange}
                    />
                    <label>{com?.Company?.name}</label>
                  </div>
                  <p className="text-sm text-themeRed text-center">
                    $ {com.tax} / Kg
                  </p>
                  <p className="text-sm text-themeRed text-center">
                    {`Duration : ${com.Company.startDay}-${com.Company.endDay} Day`}
                  </p>
                </div>
              ))}
            </div>
            <div className="flex justify-end">
              <button
                onClick={remeasuredOrder}
                className="py-1 px-4 bg-themeBlue text-white border border-themeBlue rounded
                 hover:bg-white hover:text-themeBlue"
              >
                Save
              </button>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-x-4 gap-y-4">
            <div className="bg-white py-6 px-5 rounded-lg space-y-4">
              <div className="flex justify-between items-center gap-x-4">
                <h1 className="font-medium sm:text-2xl text-xl text-themeBlue">
                  Send Package to Below Address
                </h1>
              </div>
              <div className="block">
                <table>
                  <tbody>
                    <tr>
                      <td className={tdStyle2}>Company</td>
                      <td className={tdStyle3}>
                        {data?.data?.booking?.DestinationDetail?.companyName}
                      </td>
                    </tr>
                    <tr>
                      <td className={tdStyle2}>Address</td>
                      <td className={tdStyle3}>
                        {data?.data?.booking?.DestinationDetail?.address}
                      </td>
                    </tr>
                    <tr>
                      <td className={tdStyle2}>Country</td>
                      <td className={tdStyle3}>
                        {data?.data?.booking?.DestinationDetail?.country}
                      </td>
                    </tr>
                    <tr>
                      <td className={tdStyle2}>Email</td>
                      <td className={tdStyle3}>
                        {data?.data?.booking?.DestinationDetail?.email}
                      </td>
                    </tr>
                    <tr>
                      <td className={tdStyle2}>Phone</td>
                      <td className={tdStyle3}>
                        {data?.data?.booking?.DestinationDetail?.phone}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="bg-white py-6 px-5 rounded-lg space-y-4">
              <div className="flex justify-between items-center gap-x-4">
                <h1 className="font-medium sm:text-2xl text-xl text-themeBlue">
                  Supplier Details
                </h1>
              </div>
              <div className="block">
                <table>
                  <tbody>
                    <tr>
                      <td className={tdStyle2}>Contact Name</td>
                      <td className={tdStyle3}>
                        {data?.data?.booking?.SupplierDetail?.contactName}
                      </td>
                    </tr>
                    <tr>
                      <td className={tdStyle2}>Email</td>
                      <td className={tdStyle3}>
                        {data?.data?.booking?.SupplierDetail?.email}
                      </td>
                    </tr>
                    <tr>
                      <td className={tdStyle2}>Phone</td>
                      <td className={tdStyle3}>
                        {data?.data?.booking?.SupplierDetail?.phone}
                      </td>
                    </tr>
                    <tr>
                      <td className={tdStyle2}>Tracking No#</td>
                      <td className={tdStyle3}>
                        {data?.data?.booking?.SupplierDetail?.trackingNo}
                      </td>
                    </tr>
                    <tr>
                      <td className={tdStyle2}>Tracking Link</td>
                      <td className={tdStyle3}>
                        {data?.data?.booking?.SupplierDetail?.trackingLink}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="bg-white py-6 px-5 rounded-lg space-y-4">
              <div className="flex justify-between items-center gap-x-4">
                <h1 className="font-medium sm:text-2xl text-xl text-themeBlue">
                  Consignee Details
                </h1>
              </div>
              <div className="block">
                <table>
                  <tbody>
                    <tr>
                      <td className={tdStyle2}>Company</td>
                      <td className={tdStyle3}>
                        {data?.data?.booking?.ConsigneeDetail?.companyName}
                      </td>
                    </tr>
                    <tr>
                      <td className={tdStyle2}>Address</td>
                      <td className={tdStyle3}>
                        {data?.data?.booking?.ConsigneeDetail?.address}
                      </td>
                    </tr>
                    <tr>
                      <td className={tdStyle2}>Country</td>
                      <td className={tdStyle3}>
                        {data?.data?.booking?.ConsigneeDetail?.country}
                      </td>
                    </tr>
                    <tr>
                      <td className={tdStyle2}>Email</td>
                      <td className={tdStyle3}>
                        {data?.data?.booking?.ConsigneeDetail?.email}
                      </td>
                    </tr>
                    <tr>
                      <td className={tdStyle2}>Phone</td>
                      <td className={tdStyle3}>
                        {data?.data?.booking?.ConsigneeDetail?.phone}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="bg-white py-6 px-5 rounded-lg space-y-4">
              <div className="flex justify-between items-center gap-x-4">
                <h1 className="font-medium sm:text-2xl text-xl text-themeBlue">
                  Destination Details
                </h1>
              </div>
              <div className="block">
                <table>
                  <tbody>
                    <tr>
                      <td className={tdStyle2}>Company</td>
                      <td className={tdStyle3}>
                        {data?.data?.booking?.DestinationDetail?.companyName}
                      </td>
                    </tr>
                    <tr>
                      <td className={tdStyle2}>Address</td>
                      <td className={tdStyle3}>
                        {data?.data?.booking?.DestinationDetail?.address}
                      </td>
                    </tr>
                    <tr>
                      <td className={tdStyle2}>Country</td>
                      <td className={tdStyle3}>
                        {data?.data?.booking?.DestinationDetail?.country}
                      </td>
                    </tr>
                    <tr>
                      <td className={tdStyle2}>Email</td>
                      <td className={tdStyle3}>
                        {data?.data?.booking?.DestinationDetail?.email}
                      </td>
                    </tr>
                    <tr>
                      <td className={tdStyle2}>Phone</td>
                      <td className={tdStyle3}>
                        {data?.data?.booking?.DestinationDetail?.phone}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
}
